import moment from 'moment'

let BNBFeedPrice = null
const lastTimeSynced = new Date()

const fetchBNBPrice = async () => {
    const nextSyncedTime = lastTimeSynced.getTime() + 3600000
    if (BNBFeedPrice === null || new Date().getTime() > nextSyncedTime) {
        console.log('next fetch price feed time:', moment(nextSyncedTime).format('llll'))
        const response = await fetch('https://min-api.cryptocompare.com/data/pricemultifull?fsyms=BNB&tsyms=USD')
        // eslint-disable-next-line require-atomic-updates
        BNBFeedPrice = await response.json()
    }

    return BNBFeedPrice
}

export const DogeKongZilla = {
    address: process.env.VUE_APP_DOGE_KONG_ZILLA_CONTRACT_ADDRESS,
    jsonInterface: require('../assets/contracts/DogeKongZillaToken.json')
}

const DetailERC20ABI = require('../assets/contracts/DetailERC20.json').abi


const GasLimit = 500000

export const getDogeKongZillaContract = async (web3Client) => {
    const accounts = await web3Client.eth.getAccounts()
    return new web3Client.eth.Contract(
        DogeKongZilla.jsonInterface.abi,
        DogeKongZilla.address,
        {
            gas: GasLimit,
            from: accounts[0]
        }
    )
}

export const getInteractiveContract = async (web3Client, address, contractABI) => {
    window.w3client = web3Client

    if (web3Client === null) throw new Error('Error: web3client is not initialized')

    // check for address
    if (address === '0x00') throw new Error('Error: contract address is not initialized')

    // initialize contract
    const account = await getCurrentAccount(web3Client)
    return new web3Client.eth.Contract(
        contractABI,
        address,
        {
            gas: GasLimit,
            from: account
        }
    )
}

export const getCurrentAccount = async (web3Client) => {
    let result = null
    const accounts = await web3Client.eth.getAccounts()
    if (accounts.length > 0) {
        result = accounts[0]
    }

    return result
}

export const contractCall = async (interactiveContract, methodName, params = [], useLongCache = false) => {
    const func = interactiveContract.methods[methodName](...params)
    return func.call().then(result => {
        return result
    }).catch((err) => {
        console.log({err})
    })
}

export const getDetailToken = async (web3Client, address) => {
    const contract = await getInteractiveContract(web3Client, address, DetailERC20ABI)

    const namePromise = contractCall(contract, 'name')
    const symbolPromise = contractCall(contract, 'symbol')

    const result = await Promise.all([namePromise, symbolPromise])

    const [name, symbol] = result

    return {
        name,
        symbol,
    }
}


export const getDogeKongZillaBalance = async (web3Client) => {
    const accounts = await web3Client.eth.getAccounts()
    const contract = await getDogeKongZillaContract(web3Client)
    const balance = await contract.methods.balanceOf(accounts[0]).call()
    return Number(web3Client.utils.fromWei(balance.toString(), 'gwei'))
}

export const getContractInfo = async (web3Client) => {
    const accounts = await web3Client.eth.getAccounts()
    const contract = await getDogeKongZillaContract(web3Client)
    const {RAW: {BNB: {USD: {PRICE}}}} = await fetchBNBPrice()
    const dkzBalance = await contract.methods.balanceOf(accounts[0]).call()
    const totalSupply = await contract.methods.totalSupply().call()
    const accountDividendsInfo = await contract.methods.getAccountDividendsInfo(accounts[0]).call()
    const hasUserCustomRewardToken = await contract.methods.getUserHasCustomRewardToken(accounts[0]).call()

    let currentRewardToken = null
    let infoCustomRewardToken = null

    if (hasUserCustomRewardToken) {
        currentRewardToken = await contract.methods.getUserCurrentRewardToken(accounts[0]).call()
        infoCustomRewardToken = await getDetailToken(web3Client, currentRewardToken)
    }

    const data = {
        dogeKongZillaBalance: Number(web3Client.utils.fromWei(dkzBalance.toString(), 'gwei')).toFixed(2),
        totalSupply: Number(web3Client.utils.fromWei(totalSupply.toString(), 'gwei')),
        queuePosition: Number(accountDividendsInfo[2]),
        secondsUntilAutoClaimAvailable: Number(accountDividendsInfo[7]),
        pendingReward: Number(web3Client.utils.fromWei(Number(accountDividendsInfo[3]).toString(), 'ether')).toFixed(6),
        totalReward: Number(web3Client.utils.fromWei(Number(accountDividendsInfo[4]).toString(), 'ether')).toFixed(6),
        hasUserCustomRewardToken: hasUserCustomRewardToken,
        infoCustomRewardToken: infoCustomRewardToken,
        currentRewardToken: currentRewardToken,
        bnbPrice: PRICE
    }
    return data
}

export const setRewardTokenCustom = async (web3Client, tokenAddress) => {
    const contract = await getDogeKongZillaContract(web3Client)
    const method = contract.methods.setRewardToken(tokenAddress)
    const gas = await method.estimateGas()
    await method.send({
        gas
    })
}

export const claimReward = async (web3Client) => {
    const contract = await getDogeKongZillaContract(web3Client)
    const method = contract.methods.claim()
    const gas = await method.estimateGas()

    await method.send({
        gas
    })
}

export const revertBNBToKenReward = async (web3Client) => {
    const contract = await getDogeKongZillaContract(web3Client)
    const method = contract.methods.unsetRewardToken()
    const gas = await method.estimateGas()

    await method.send({
        gas
    })
}


